export default __webpack_public_path__ + "static/media/gallery_08.89cc9eb2.jpg";